// /alarms DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import { EditButton } from "@refinedev/mui";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { IAlarm } from "../interfaces";

export const alarmColumns: GridColDef<IAlarm>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "message",
    headerName: "메시지",
    type: "string",
    width: 363,
    minWidth: 290,
  },
  {
    field: "userId",
    headerName: "수신자ID",
    type: "string",
    width: 120,
    minWidth: 100,
  },
  { field: "dtype", headerName: "유형", type: "string", width: 225, minWidth: 180 },
  {
    field: "createdDate",
    headerName: "발송일",
    type: "string",
    width: 236,
    minWidth: 190,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
